import {default as globals} from '../base/_globals.js';

const mainMenu = document.getElementById('main_menu');
let listItemsWithChildren = null;
let timer = null;

if ( mainMenu ) {
	listItemsWithChildren = mainMenu.querySelectorAll('.menu-item-has-children');	
} 

/**
 *
 *
 *
 */
const init = function() {
	
	if ( listItemsWithChildren ) {

		Array.prototype.forEach.call(listItemsWithChildren, function( el ) {

			const a = el.querySelector('a');

			el.addEventListener("mouseover", () => {
				showSubmenu(el);
			});

			el.addEventListener("mouseout", () => {
				timer = setTimeout( () => {
					hideSubmenu(el);
				}, 1000);
			});
			
			a.addEventListener("focus", () => {
				showSubmenu(el);
			});

			el.addEventListener('focusout', (e) => {
				if ( !el.contains(e.relatedTarget) ) {
					hideSubmenu(el);
				}
			});

		});

	}

};


const showSubmenu = function(el) {
	if ( window.innerWidth >= globals.breakpoint ) {
		el.classList.add('submenu-visible');
		el.setAttribute('aria-expanded', 'true');
		clearTimeout(timer);
	} else {
		el.classList.remove('submenu-visible');
		el.removeAttribute('aria-expanded');
	}
};


const hideSubmenu = function(el) {
	if ( window.innerWidth >= globals.breakpoint ) {
		el.classList.remove('submenu-visible');
		el.setAttribute('aria-expanded', 'false');
	} else {
		el.classList.remove('submenu-visible');
		el.removeAttribute('aria-expanded');
	}
}


const api = {
	init: init
};

export default api;